import { cx } from 'class-variance-authority';
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

type CommandGroupProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Group>;

const CommandGroup = forwardRef<HTMLDivElement, CommandGroupProps>(({ className, heading, ...props }, ref) => (
  <CommandPrimitive.Group
    ref={ref}
    heading={heading}
    className={cx(
      'not-first:mt-2 px-1 text-caption-1',
      '[&_[cmdk-group-heading]]:text-tertiary [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:user-select-none',
      className,
    )}
    {...props}
  />
));

export default CommandGroup;
